import React from 'react';
import { Modal, ListGroup } from 'react-bootstrap';
import { IconBuilding } from '@tabler/icons-react';

// Impor Tipe V4
import { UserV4 } from '../schemas/UserV4Schema';

/**
 * Props untuk komponen ViewUserPropertiesDialogV4.
 * @param show - Boolean untuk mengontrol visibilitas dialog.
 * @param onClose - Callback function yang dipanggil saat dialog ditutup.
 * @param user - Objek pengguna yang propertinya akan ditampilkan. Bisa null.
 */
interface ViewUserPropertiesDialogV4Props {
    show: boolean;
    onClose: () => void;
    user: UserV4 | null;
}

/**
 * Komponen dialog (Modal) untuk menampilkan daftar properti
 * yang terhubung dengan pengguna dalam mode read-only (Versi 4).
 */
const ViewUserPropertiesDialogV4: React.FC<ViewUserPropertiesDialogV4Props> = ({ show, onClose, user }) => {

    // Jika tidak ada pengguna yang dipilih, jangan render apa pun.
    // Ini adalah guard clause untuk mencegah error jika prop 'user' null.
    if (!user) {
        return null;
    }

    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>
                    Properties for <span className="text-primary">{user.name}</span>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                {user.properties && user.properties.length > 0 ? (
                    <ListGroup variant="flush">
                        {user.properties.map(property => (
                            <ListGroup.Item
                                key={property.id}
                                className="d-flex justify-content-between align-items-center"
                            >
                                <div className="d-flex align-items-center">
                                    <IconBuilding className="me-3 text-muted" size={20} />
                                    <span>{property.name}</span>
                                </div>
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                ) : (
                    <div className="text-center text-muted p-4">
                        <p className="mb-0">This user is not assigned to any properties.</p>
                    </div>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default ViewUserPropertiesDialogV4;